import api from '@/lib/api';

let ws = null;
let listeners = {};
let reconnectTimer = null;

export async function connectWS() {
  try {
    const { data } = await api.get('/auth/ws-token');
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    const wsUrl = API_URL.replace('https://', 'wss://').replace('http://', 'ws://');
    ws = new WebSocket(`${wsUrl}/api/ws/${data.token}`);
    ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        const cbs = listeners[msg.type] || [];
        cbs.forEach(cb => cb(msg.data));
      } catch {}
    };
    ws.onclose = () => {
      ws = null;
      reconnectTimer = setTimeout(connectWS, 5000);
    };
    ws.onerror = () => {};
  } catch {}
}

export function disconnectWS() {
  if (reconnectTimer) clearTimeout(reconnectTimer);
  reconnectTimer = null;
  if (ws) { ws.close(); ws = null; }
}

export function onWSEvent(type, callback) {
  if (!listeners[type]) listeners[type] = [];
  listeners[type].push(callback);
  return () => {
    listeners[type] = (listeners[type] || []).filter(cb => cb !== callback);
  };
}
